// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  env: 'dev',
  apiUrls: {
    // api: 'https://shootflow.bcoder.co.in',
    api: 'https://dev.shootflow.bcoder.co.in',
    // api: 'https://earthvirtual.codingcopz.in',
    // api: 'https://crm.earthvirtual.com',
  },
  firebaseCollectionUrl: 'messages',
  firebaseConfig: {
    apiKey: 'AIzaSyDAQPgBAlovYvM9dNC1XYMsVmZUoW3fyHU',
    authDomain: 'earthvirtual-f6eb8.firebaseapp.com',
    databaseURL: 'https://earthvirtual-f6eb8-default-rtdb.firebaseio.com',
    projectId: 'earthvirtual-f6eb8',
    storageBucket: 'earthvirtual-f6eb8.appspot.com',
    messagingSenderId: '372579449108',
    appId: '1:372579449108:web:10dfd73af33720e3a26a01',
    measurementId: 'G-L3NX149NDQ',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
